import React from "react";
import ReactModal from "react-modal";
import styled from "styled-components";
import { Close } from "@material-ui/icons";

const StyledClose = styled(Close)`
  cursor: pointer;
`;
const FlexHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
const TitleBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  font-size: 18px;
  padding: 18px;
  border-bottom: 1px solid #f1f1f1;
  margin-bottom: ${({ noBottomMargin }) => (noBottomMargin ? "0px" : "15px")};
`;

function Modal({
  isOpen,
  onRequestClose,
  Icon,
  smallModal,
  modalTitle,
  noBottomMargin,
  FavIcon,
  children,
}) {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      padding: "0px",
      bottom: "auto",
      height: smallModal ? "150px" : "100%",
      width: "100%",
      maxWidth: "1000px",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
    overlay: {
      backgroundColor: "rgba(0,0,0,0.3)",
      zIndex: "99",
    },
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      contentLabel="Example Modal"
      ariaHideApp={false}
    >
      <TitleBlock noBottomMargin={noBottomMargin}>
        <FlexHolder>
          {Icon && <Icon fontSize="small" style={{ marginRight: "5px" }} />}
          <span>{modalTitle}</span>
          {FavIcon || null}
        </FlexHolder>
        {onRequestClose ? (
          <div title="Schließen" alt="Schließen">
            <StyledClose onClick={onRequestClose} />
          </div>
        ) : null}
      </TitleBlock>
      {children}
    </ReactModal>
  );
}

export default Modal;
